export const SELECTIONS = {
  ALL: 'select-all',
  NONE: 'select-none',
};

export const OPTIONS = [
  {
    id: SELECTIONS.ALL,
    label: 'Select All',
    value: SELECTIONS.ALL,
  },
  {
    id: SELECTIONS.NONE,
    label: 'Select None',
    value: SELECTIONS.NONE,
  },
];
